import { render, staticRenderFns } from "./DeleteJunkRequirement.vue?vue&type=template&id=96e4b758"
import script from "./DeleteJunkRequirement.vue?vue&type=script&lang=js"
export * from "./DeleteJunkRequirement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports